import { useEffect, useState } from 'react';

export function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="ow-back-to-top ow-focusable fixed bottom-6 right-6 z-40 flex items-center justify-center"
      style={{
        width: 44,
        height: 44,
        borderRadius: '50%',
        boxShadow: 'var(--ow-shadow-lg)',
        border: '1px solid var(--ow-gold)',
        animation: 'ow-fade-up 300ms var(--ow-ease-soft) both',
      }}
    >
      <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <line x1="9" y1="14" x2="9" y2="3" />
        <path d="M4 8 L9 3 L14 8" />
      </svg>
    </button>
  );
}
